import { render } from "./NavigationBetting.vue?vue&type=template&id=4a05d4d3"
import script from "./NavigationBetting.vue?vue&type=script&lang=js"
export * from "./NavigationBetting.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__